import {Component, inject, Input, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {selectCopyAssetValuationsWorkflowStepFlag, selectCopyConfig, selectCopyResponse} from "../../store/fund/fund.selectors";
import {Store} from "@ngrx/store";
import {filter, map, Subscription} from "rxjs";
import {CopyFundReportAndValuationsActions} from "../../store/fund.actions";
import {CopyConfig} from "../../models/copy-config";
import {MatStepper} from "@angular/material/stepper";
import {MatDialogRef} from "@angular/material/dialog";
import {AssetValuationCopyDialogComponent} from "./asset-valuation-copy-dialog/asset-valuation-copy-dialog.component";

@Component({
    selector: "valumize-fund-copy-workflow-stepper",
    templateUrl: "./fund-copy-workflow-stepper.component.html",
    styleUrl: "./fund-copy-workflow-stepper.component.scss",
    standalone: false
})
export class FundCopyWorkflowStepperComponent implements OnInit, OnDestroy {
    private readonly store = inject(Store);
    private readonly dialogRef = inject(MatDialogRef<FundCopyWorkflowStepperComponent>);

    @Input() startWith: "report" | "valuation" = "report";
    @Input() fundId?: number;
    @Input() fundReportId?: number;

    @ViewChild("stepper") stepper!: MatStepper;
    @ViewChild("assetValuationCopyDialog") assetValuationCopyDialog?: AssetValuationCopyDialogComponent;

    subscriptions: Subscription[] = [];
    copyConfig$ = this.store.select(selectCopyConfig);
    showCopyAssetValuationsStep = false;
    isCopying = false;
    copyErrorMessage = "";

    constructor( ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(this.store.select(selectCopyAssetValuationsWorkflowStepFlag).pipe(map(value => this.showCopyAssetValuationsStep = value)).subscribe());

        this.subscriptions.push(this.store.select(selectCopyResponse).pipe(
            filter(response => response.status === "LOADED" || response.status === "ERROR"),
            map(response => {
                this.isCopying = false;
                if (response.status === "LOADED") {
                    this.dialogRef.close();
                } else if (response.status === "ERROR") {
                    this.copyErrorMessage = response.errorMessage;
                }
            })
        ).subscribe());
    }

    getDialogTitle = () => this.startWith === "report" ? "Copy Fund Report & Valuations Workflow" : "Copy Fund Valuation Workflow";

    copy(copyConfig: CopyConfig): void {
        this.isCopying = true;
        this.copyErrorMessage = "";
        this.store.dispatch(CopyFundReportAndValuationsActions.copy({copyConfig}));
    }

    onNavigateToAssetValuationStep(): void {
        this.stepper.next();
        // Use setTimeout to ensure ViewChild is resolved after @if renders the component
        setTimeout(() => this.assetValuationCopyDialog?.loadAssetValuations());
    }

    onCancel = () => {
        this.store.dispatch(CopyFundReportAndValuationsActions.clearCopyConfigAndWorkflow());
        this.dialogRef.close();
    }

    ngOnDestroy = () => this.subscriptions.forEach(sub => sub.unsubscribe());
}
